import env from '@/config/env';
import UFs from '@/graphql/tabela/queries/Uf.gql';
import * as types from '@/store/types/global.types';

export default {
  namespaced: true,
  state: {
    loading: false,
    ufs: [],
  },
  getters: {
    ufs: state => state.ufs,
    ufSiglas: state => state.ufs.map(f => f.sigla),
    loading: state => state.loading,
  },
  mutations: {
    [types.ADD](state, payload) {
      state.ufs = payload.uf;
    },
    [types.LOADING](state, payload) {
      state.loading = payload.loading;
    },
  },
  actions: {
    async setUF({ state, commit, dispatch }) {
      commit(types.LOADING, { loading: true });
      try {
        if (state.ufs.length) return;
        const { data } = await env.apollo.query({
          query: UFs,
        });
        const { uf } = data;
        commit(types.ADD, { uf });
        commit(types.LOADING, { loading: false });
      } catch (err) {
        dispatch(
          'error/setError',
          {
            message: 'Não foi possível carregar as UFs',
          },
          {
            root: true,
          },
        );
      }
    },
  },
};
